export default __webpack_public_path__ + "static/cover-a30b04e37f96f3eefccab25ce3137764.png";